module.exports = __webpack_public_path__ + "img/ico_lock.12920939.svg";